import { urls } from "../../urls";

const fetchRenewData = async (subscriptionId: string, username: string) => {
    const rapbackUrl = urls.RAPBACK
    const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/renew/${subscriptionId}?username=${username}`;
    console.log(`Validations handleRenew hook url: ${url}`)
    try {
        return await fetch(url, {
            method: "POST",
            credentials: "include"
        })
    } catch (err: any) {
        console.error('error querying rapback unsubscribe: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchRenewData